<template>
  <div class="container">
    <v-form class="login">
      <h1>Sign In</h1>
      <v-text-field
        type="email"
        placeholder="Email address..."
        v-model="email"
        append-outer-icon="mdi-email"
      />
      <v-text-field
        placeholder="password..."
        v-model="password"
        id="password"
        name="password"
        :type="show ? 'text' : 'password'"
        :append-outer-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
        @click:append-outer="show = !show"
      />
      <v-btn @click="login" :loading="loading" class="primary">Sign In</v-btn>
    </v-form>
    <router-link to="/change-password">Change Password</router-link>
  </div>
</template>

<script>
import firebase from "firebase";

export default {
  name: "Home",
  data() {
    return {
      email: "",
      password: "",
      loading: false,
      show:false
    };
  },
  methods: {
    login() {
      console.log("ssssssss");
      this.loading = true;
      firebase
        .auth()
        .signInWithEmailAndPassword(this.email, this.password)
        .then(() => {
          this.loading = false;
          this.$router.push("/pandemic_List");
        })
        .catch((error) => {
          alert(error.message);
          this.loading = false;
        });
    },
  },
};
</script>

<style scoped>
.container {
  max-width: 1140px;
}
h1 {
  font-size: 50px;
}
.login {
  display: flex;
  flex-direction: column;
  justify-content: center;
  width: 50%;
  margin: 40px auto;
}
h1 {
  text-align: center;
  padding: 50px;
}
button {
  width: 200px;
  margin: 0 auto;
  margin-top: 20px;
}
</style>